//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 30.09.2015.
 */

(function () {

    'use strict';

    const defaultOptions = {
        dimensions: {
            rowHeight: 32,
            headerHeight: 32,
            toolbarHeight: 0,
            filterRowHeight: 32
        },
        containColumnDragging: false,
        showRowCounter: false,
        settingsAvailable: false,
        showSelectColumn: true,
        showActionColumn: true,
        multiSelect: true,
        showSelectAll: true,
        selectOnRowClick: false,
        enableSorting: false,
        showHeader: false,
        showActionForSelectedItems: true,
        showGroupBy: false,
        showFooter: true,
        showEmptyLineAtEnd: false,
        // code added for SRSNG-5903
        itemsSelected: false,
        itemAnchoring: false,
        pagination: {
            available: false
        },
        model: {
            displayFilter: false,
            filterAvailable: false,
            columns: [],
            columnGroups: []
        },
        events: {}
    };

    angular.module('container.widgets')
        .directive('srsngMegaTable', srsngMegaTable);

    function srsngMegaTable($window,
        $compile,
        $timeout,
        $filter,
        $translate,
        sortService,
        MegaTableColumnKey,
        MegaTableItemProperty,
        SortDirection,
        SortDataType,
        tableColumnDateFilterService,
        tableColumnDurationFilterService,
        tableColumnFileSizeFilterService,
        tableColumnIpAddressFilterService,
        tableColumnTextFilterService,
        pagingtableColumnTextFilterService,
        tableColumnNumberFilterService) {
        return {
            restrict: 'E',
            scope: {
                options: '='
            },
            transclude: {
                footer: '?srsngMegaTableFooter'
            },
            templateUrl: 'container/ui/app/widgets/mega-table/mega-table.html',
            link: link
        };

        function link(scope, element, attrs) {

            let options;
            let megaTable;
            let anchoredItemValue = null;
            let anchoredItemExtraScrollTop = 0;
            var itemActionMenuRowIndex = -1;
            var canShowItemActionMenu = true;

            scope.rowGrouping = {};
            scope.columnFilterData = {};
            scope.showHeader = false;
            scope.showFooter = false;
            scope.filterSettings = {
                searchText: '',
                fromDate: null,
                toDate: null,
                fromSize: null,
                toSize: null
            }

            createOptions(scope.options);
            element.children('.mega-table').megatable(options);

            scope.itemActionMenu = {
                items: options.itemActionMenu,
                visible: false
            };

            scope.actionMenuVisible = {};

            scope.tableActionMenu = {
                visible: false,
                items: options.tableActionMenu
                /*items: [
                    'Export to json',
                    'Export to csv',
                    'Export to xlsx',
                    'Multi Filter Editor',
                    'Save Result',
                    'Share'
                ]*/
            };

            scope.selectedItemsActionMenu = {
                visible: false,
                items: options.selectedItemsActionMenu
                /*items: [
                    'Transfer to DMZ',
                    'Download',
                    'Zip&Download',
                    'Share'
                ]*/
            };


            scope.$watch('itemActionMenu.visible', function (newValue) {
                if (newValue === false) {
                    //oldItemActionMenuRowIndex = itemActionMenuRowIndex;
                    canShowItemActionMenu = false;
                    setTimeout(function () {
                        canShowItemActionMenu = true;
                    }, 0);
                }
            });

            scope.$watch('columnFilterData.visible', function (newValue, oldValue) {
                if (newValue)
                    return;

                if (scope.columnFilterData.element) {
                    scope.columnFilterData.element.remove();
                    scope.columnFilterData.element = null;
                }

                scope.columnFilterData.clickTimeoutActive = true;

                setTimeout(() => scope.columnFilterData.clickTimeoutActive = false);
            });

            scope.getSelectedItemCount = (options.header && options.header.getSelectedItemCount) || (() => {
                if (options.dataSource.items() != null) {
                    return options.dataSource.items().filter(item => item[MegaTableItemProperty.SELECTED]).length;
                }
                else {
                    return 0;
                }
            });

            scope.getFilteredItemCount = (options.header && options.header.getFilteredItemCount) || (() => {
                if (options.dataSource.items() != null) {
                    return options.dataSource.items().length;
                }
                else {
                    return 0;
                }
            });

            scope.getTotalItemCount = (options.header && options.header.getTotalItemCount) || (() => {
                if (options.dataSource.unfilteredItems) {

                    let items = options.dataSource.unfilteredItems();

                    if (Array.isArray(items)) {
                        return items.length;
                    }
                }

                return options.dataSource.items().length
            });

            scope.getRowGroupToggleIconUrl = isExpanded => {
                return `container/ui/assets/img/icons/system-icons-16x16/system-ic-${isExpanded ? 'minus' : 'plus'}-16x16.svg`;
            };

            scope.removeRowGrouping = skipInit => {
                //options.model.columns = scope.rowGrouping.columns;
                scope.rowGrouping = {};

                //if (!skipInit) megaTable.init(options);
                //options.itemsFiltered(options.dataSource.unfilteredItems().slice());

                // Code Added to apply the update functionality in an asynchronous call
                $timeout(function () {
                    megaTable.updateData(true);
                }, 0);
            };

            scope.toggleSelect = function (event, rowIndex) {
                let targetItem = options.dataSource.items()[rowIndex];

                if (targetItem) {
                    setRowSelected(rowIndex, !targetItem[MegaTableItemProperty.SELECTED]);
                }

                if (options.multiSelect) {

                    scope.allSelected = options.dataSource.items().every(item => item[MegaTableItemProperty.SELECTED]);

                } else if (targetItem && targetItem[MegaTableItemProperty.SELECTED]) {

                    options.dataSource.items().forEach((item, index) => {
                        if (item != targetItem) setRowSelected(index, false);
                    });
                }
                event.stopPropagation();
            };

            scope.toggleSelectAll = function (event) {
                scope.allSelected = !scope.allSelected;

                options.dataSource.items().forEach((item, index) => setRowSelected(index, scope.allSelected));

                event.stopPropagation();
            };

            scope.toggleMenu = function (event, rowIndex) {
                if (!canShowItemActionMenu && rowIndex == itemActionMenuRowIndex) {
                    canShowItemActionMenu = true;
                } else {
                    itemActionMenuRowIndex = rowIndex;
                    scope.itemActionMenu.visible = true;

                    $compile(`
                    <srsng-popup class="table-action-menu-popup" visible="itemActionMenu.visible" target=".action-menu-button svg" anchor="left center" align="right center" offset="-8 0" arrow="right" remove-on-hide>
                            <div class="action-menu">
                                <div class="list">
                                    <div ng-repeat="item in itemActionMenu.items" 
                                    ng-init="enabled = (item.enabled(${rowIndex}) == true || item.enabled(${rowIndex}) === undefined); optionVisible = (item.visible(${rowIndex}) == true || item.visible(${rowIndex}) === undefined)"
                                    ng-show="optionVisible" data-cy="action-menu-{{item.label}}"
                                    class="item ng-class:{disabled:!enabled}"
                                    ng-click="enabled && item.callback(${rowIndex}); enabled && (itemActionMenu.visible = false)">
                                        <span class="label">{{item.label | translate}}</span>
                                        <ng-include ng-if="!enabled" src="'container/ui/assets/img/icons/system-icons-16x16/system-ic-locked-16x16.svg'" class="lock-image"></ng-include>
                                    </div>
                                </div>
                            </div>
                        </srsng-popup>
                    `)(scope).insertAfter(event.currentTarget);
                }
                event.stopPropagation();
            };

            scope.itemActionMenuActive = function (rowIndex) {
                return scope.itemActionMenu.visible && rowIndex == itemActionMenuRowIndex;
            };

            scope.toggleColumnFilter = function (event, columnKey) {
                if (columnKey === scope.columnFilterData.columnKey) {
                    scope.filterSettings.searchText = scope.columnFilterData.searchText;
                    scope.filterSettings.fromDate = scope.columnFilterData.fromDate;
                    scope.filterSettings.toDate = scope.columnFilterData.toDate;
                    scope.filterSettings.fromSize = scope.columnFilterData.fromSize;
                    scope.filterSettings.toSize = scope.columnFilterData.toSize;
                } else {
                    scope.filterSettings = {};
                }
                //code changes for the checkbox sorting(check for filter not display for select option)
                if ((columnKey != scope.columnFilterData.columnKey || !scope.columnFilterData.clickTimeoutActive) && (columnKey !== MegaTableColumnKey.SELECT)) {

                    assignColumnFilterData(columnKey);

                    scope.columnFilterData.element = $compile(`
                        <srsng-table-column-${scope.columnFilterData.filterType}-filter data="columnFilterData">                     
                        </srsng-table-column-${scope.columnFilterData.filterType}-filter>
                    `)(scope).insertAfter(event.currentTarget);

                } else {
                    scope.columnFilterData.clickTimeoutActive = false;
                }

                event.stopPropagation();
            };

            function assignColumnFilterData(columnKey) {
                let column = getColumn(columnKey);
                let filterType = column.dataType;
                let showFilter = column.showFilter || false;

                if (!filterType) {
                    return;
                }

                if (columnKey != scope.columnFilterData.columnKey) {

                    if (scope.columnFilterData.columnKey) getColumn(scope.columnFilterData.columnKey).filtered = false;
                    scope.columnFilterData = {};
                }

                _.assign(scope.columnFilterData, {
                    columnKey: columnKey,
                    column: column,
                    callback: options.filters && options.filters[filterType] ? options.filters[filterType] : getFilterService(filterType).filter,
                    popupTarget: '.column-header-content',
                    itemsFiltered: filteredItems => {
                        updateColumnSortState(columnKey, column.sortDirection);
                        column.filtered = filteredItems.length < options.dataSource.unfilteredItems().length;
                        options.itemsFiltered(filteredItems);
                        if (scope.rowGrouping.columnKey) setRowGrouping(scope.rowGrouping.columnKey);
                        megaTable.updateData(true);
                        let group = element.find('.column-group-body:first');
                        group.trigger('ps-scroll-y');
                    },
                    visible: true,
                    paging: options.paging,
                    clickTimeoutActive: false,
                    items: options.dataSource.items(),
                    unfilteredItems: options.dataSource.unfilteredItems(),
                    filterType: (() => {
                        switch (filterType) {
                            case SortDataType.TEXT: default: return 'text';
                            case SortDataType.DATE: return 'date';
                            case SortDataType.DURATION: return 'duration';
                            case SortDataType.FILE_SIZE: return 'file-size';
                            case SortDataType.IP_ADDRESS: return 'ip-address';
                            case SortDataType.NUMBER: return 'number';
                        }
                    })(),
                    showFilter: showFilter,
                    searchText: scope.filterSettings.searchText,
                    fromDate: scope.filterSettings.fromDate,
                    toDate: scope.filterSettings.toDate,
                    fromSize: scope.filterSettings.fromSize,
                    toSize: scope.filterSettings.toSize
                });
            }

            scope.getHeaderSortIconUrl = columnKey => {
                if (columnKey === MegaTableColumnKey.ROW_OVERLAY) return;
                let sortDirection = getColumn(columnKey).sortDirection;

                let icon;

                if (sortDirection == 'asc')
                    icon = 'up-';
                else if (sortDirection == 'desc')
                    icon = 'down-';
                else
                    icon = '';

                return `container/ui/assets/img/icons/system-icons-16x16/system-ic-sort-${icon}16x16.svg`;
            };

            scope.getHeaderFilterIconUrl = columnKey => {
                return getColumn(columnKey).filtered ? 'container/ui/assets/img/icons/system-icons-16x16/system-ic-filter-16x16.svg' : '';
            };

            scope.sortColumn = (event, columnKey) => {
                const column = options.model.columns.find(column => column.key === columnKey);
                const sortDirection = column.sortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
                if (options.paging)  {
                    const data = {
                        itemsFiltered: options.itemsFiltered,
                        paging: {
                            "currentPage": options.paging.currentPage
                        },
                        columnKey: columnKey,
                        column: {
                            sortDirection: sortDirection
                        }
                    };
                    pagingtableColumnTextFilterService.sorting(data);
                    updateColumnSortState(columnKey, sortDirection);                    
                } else {
                    megaTable.sortColumn(columnKey, sortDirection);
                    megaTable.updateData(true);                
                }                            

                event.stopPropagation();
            };

            scope.toggleSelectedItemsActionMenu = function () {
                scope.selectedItemsActionMenu.visible = !scope.selectedItemsActionMenu.visible;
            };

            scope.toggleTableActionMenu = function () {
                scope.tableActionMenu.visible = !scope.tableActionMenu.visible;
            };

            function createOptions(customOptions) {

                options = _.merge({}, defaultOptions, customOptions);

                if (options.showHeader !== undefined) scope.showHeader = options.showHeader;
                if (options.showFooter !== undefined) scope.showFooter = options.showFooter;
                if (options.showGroupBy !== undefined) scope.showGroupBy = options.showGroupBy;
                if (options.showActionForSelectedItems !== undefined) scope.showActionForSelectedItems = options.showActionForSelectedItems;


                // code added for SRSNG-5903
                if (options.itemsSelected !== undefined) scope.itemsSelected = options.itemsSelected;

                var initializeFn = options.initialize;

                options.initialize = function (mt) {

                    for (var i = 0; i < mt.columnGroups.length; i++) {
                        if (mt.columnGroups[i].locked !== true) {
                            mt.columnGroups[i].columns.sort(function (column1, column2) {
                                return column1.columnModel.order < column2.columnModel.order ? -1 : column1.columnModel.order > column2.columnModel.order ? 1 : 0;
                            });
                        }
                    }
                    scope.rowGrouping.columnKey = options.defaultRowGroupingColumnKey;
                    megaTable = mt;

                    new ResizeObserver(function () {
                        megaTable.updateLayout();
                        megaTable.updateLayout(); //For some reason this still needs to be called twice
                    }).observe(megaTable.container.get(0));

                    var megaTableInitFn = megaTable.init;
                    megaTable.init = function (customOptions) {
                        createOptions(customOptions);
                        megaTableInitFn.call(this, options);

                    };
                    let megaTableUpdateDataFn = megaTable.updateData;

                    megaTable.updateData = function (callInternalOnly) {
                        if (!callInternalOnly) {
                            if (options.itemAnchoring) {
                                if (anchoredItemValue !== null) {
                                    let index = options.dataSource.items().findIndex(item => item[options.itemAnchoring.key] === anchoredItemValue);
                                    let scrollTop = options.dimensions.rowHeight * index - anchoredItemExtraScrollTop;
                                    let group = element.find('.column-group-body:first');
                                    group.scrollTop(scrollTop);
                                    group.trigger('ps-scroll-y');
                                }
                            }
                            const column = options.model.columns.find(column => column.sortDirection);
                            if (column) {
                                megaTable.sortColumn(column.key, column.sortDirection);
                            }
                        }
                        if (!callInternalOnly && scope.columnFilterData.columnKey) {
                            assignColumnFilterData(scope.columnFilterData.columnKey);
                            getFilterService(scope.columnFilterData.column.dataType).filter(scope.columnFilterData);
                        } else if (!callInternalOnly && !scope.columnFilterData.columnKey && scope.rowGrouping.columnKey) {
                            setRowGrouping(scope.rowGrouping.columnKey);
                            megaTableUpdateDataFn.call(this);
                        } else {
                            megaTableUpdateDataFn.call(this);
                        }
                    };

                    megaTable.getColumnOrder = () => {
                        var updatedColumnsModel = {
                            columns: []
                        };
                        megaTable.getUpdatedColumnOrder(updatedColumnsModel);
                        return updatedColumnsModel;
                    };

                    megaTable.sortColumn = (columnKey, sortDirection) => {

                        let column = options.model.columns.find(column => column.key === columnKey);

                        let items;
                        switch (columnKey) {
                            case MegaTableColumnKey.ACTION: {
                                return;
                            }
                            default: {

                                if (options.sort) {
                                    items = options.sort(columnKey, sortDirection);
                                }
                                if (!items) {
                                    items = sortService.getSortFn(column.dataType)(options.dataSource.items(), columnKey, sortDirection);
                                }
                                break;
                            }
                        }

                        if (scope.rowGrouping.column) {
                            items = sortService.getSortFn(scope.rowGrouping.column.dataType)(items, scope.rowGrouping.columnKey, SortDirection.ASC);
                        }

                        updateColumnSortState(columnKey, sortDirection);
                        options.itemsFiltered(items);
                    };

                    megaTable.resetColumnFilters = () => {
                        if (scope.columnFilterData.columnKey) getColumn(scope.columnFilterData.columnKey).filtered = false;
                        scope.columnFilterData = {};
                        scope.filterSettings = {};
                        let filteredItems = options.dataSource.unfilteredItems().slice();
                        options.itemsFiltered(filteredItems);
                        //if (scope.rowGrouping.columnKey) setRowGrouping(scope.rowGrouping.columnKey);

                        const column = options.model.columns.find(column => column.sortDirection);

                        if (column) {
                            megaTable.sortColumn(column.key, column.sortDirection);
                        }

                        megaTable.updateData(true);
                    };

                    megaTable.exportCurrentFilters = () => {
                        let sortedColumn = options.model.columns.find(c => c.sortDirection);

                        scope.filterSettings.searchText = scope.columnFilterData.searchText;
                        scope.filterSettings.fromDate = scope.columnFilterData.fromDate;
                        scope.filterSettings.toDate = scope.columnFilterData.toDate;
                        scope.filterSettings.fromSize = scope.columnFilterData.fromSize;
                        scope.filterSettings.toSize = scope.columnFilterData.toSize;

                        return {
                            filterData: {
                                columnKey: scope.columnFilterData.columnKey,
                                filterSettings: {
                                    searchText: scope.columnFilterData.searchText,
                                    fromDate: scope.columnFilterData.fromDate,
                                    toDate: scope.columnFilterData.toDate,
                                    fromSize: scope.columnFilterData.fromSize,
                                    toSize: scope.columnFilterData.toSize
                                }
                            },
                            sortSettings: {
                                columnKey: sortedColumn ? sortedColumn.key : undefined,
                                direction: sortedColumn ? sortedColumn.sortDirection : undefined
                            }
                        };
                    };

                    megaTable.restoreFilters = filters => {
                        if (filters && filters.filterData && filters.filterData.columnKey) {
                            scope.filterSettings = filters.filterData.filterSettings;
                            assignColumnFilterData(filters.filterData.columnKey);
                            getFilterService(scope.columnFilterData.column.dataType).filter(scope.columnFilterData);
                        }
                        if (filters && filters.sortSettings && filters.sortSettings.columnKey && filters.sortSettings.direction) {
                            megaTable.sortColumn(filters.sortSettings.columnKey, filters.sortSettings.direction);
                            megaTable.updateData(true);
                        }
                    }

                    if (initializeFn) initializeFn(mt);
                };

                if (options.showSelectColumn && !options.model.columns.some(column => column.key === MegaTableColumnKey.SELECT))
                    createSelectColumn(options);

                if (options.showActionColumn && !options.model.columns.some(column => column.key === MegaTableColumnKey.ACTION))
                    createActionColumn(options);

                let dataSourceFns = {};

                dataSourceFns.items = options.dataSource.items;
                options.dataSource.items = () => {

                    return dataSourceFns.items();
                };

                dataSourceFns.cellContent = options.dataSource.cellContent;
                options.dataSource.cellContent = (columnKey, rowIndex) => {

                    if (scope.rowGrouping.column) {

                        let group = scope.rowGrouping.groups.find(group => rowIndex >= group.itemStartIndex && rowIndex <= group.itemEndIndex);

                        if (!group) return;

                        rowIndex -= group.itemOffset;
                    }

                    if (!options.dataSource.items()[rowIndex]) {
                        return;
                    }

                    let elm;

                    switch (columnKey) {

                        case MegaTableColumnKey.SELECT: {
                            elm = $compile(`
                            <div class="select-button"
                                data-cy="mega-table-select${rowIndex}"
                                ng-click="toggleSelect($event, ${rowIndex})">
                                <ng-include src="getBodyCheckboxUrl(${rowIndex})"></ng-include>
                            </div>
                                    `)(scope.$new());
                            break;
                        }
                        case MegaTableColumnKey.ACTION: {
                            elm = $compile(`
                                <div class="action-menu-button" data-cy="mega-table-action${rowIndex}"
                                ng-class="{active: itemActionMenuActive(${rowIndex})}"
                                ng-click="toggleMenu($event, ${rowIndex})">
                                <ng-include src="'container/ui/assets/img/icons/system-icons-16x16/system-ic-action-16x16.svg'"></ng-include>
                            </div>
                                    `)(scope.$new());
                            break;
                        }
                        default: {
                            elm = dataSourceFns.cellContent(columnKey, rowIndex);
                            return elm;
                        }
                    }

                    elm.on('$destroy', () => {
                        if (elm.scope() && elm.scope() != scope) {
                            elm.scope().$destroy();
                        }
                    });

                    return elm;
                };

                dataSourceFns.rowCount = options.dataSource.rowCount;
                options.dataSource.rowCount = () => {
                    let emptyLine = 0;
                    if (options.showEmptyLineAtEnd) emptyLine = 1;
                    return dataSourceFns.rowCount() + (scope.rowGrouping.column ? scope.rowGrouping.groups.length : 0) + emptyLine;
                };

                dataSourceFns.itemAt = options.dataSource.itemAt;
                options.dataSource.itemAt = rowIndex => {

                    if (scope.rowGrouping.column) {

                        let group = scope.rowGrouping.groups.find(group => rowIndex >= group.itemStartIndex && rowIndex <= group.itemEndIndex);
                        if (!group) return;
                        rowIndex -= group.itemOffset;
                    }

                    return dataSourceFns.itemAt(rowIndex);
                };

                //var columnHeaderContentFn = options.columnHeaderContent;

                options.columnHeaderContent = function (columnKey) {
                    let innerContent;
                    let sortable = true;

                    switch (columnKey) {
                        case MegaTableColumnKey.ACTION: {

                            innerContent = `<div class="column-header-title">{{"container.megaTable.action" | translate}}</div>`;
                            // $filter('translate')('container.megaTable.action');
                            sortable = false;
                            break;
                        }
                        case MegaTableColumnKey.SELECT: {

                            if (options.multiSelect && options.showSelectAll) {
                                innerContent = `<div class="column-header-title">
                                                    <div class="select-button"
                                                        ng-click="toggleSelectAll($event)"
                                                        ng-include="getHeaderCheckboxUrl()">
                                                    </div>
                                               </div>`;
                            } else {
                                innerContent = '<div class="column-header-title"></div>';
                            }

                            break;
                        }
                        default: {
                            let title = options.model.columns.find(column => column.key === columnKey).title;

                            // Only translate if the title isn't already being translated by the caller
                            if (title && !/\|\s?translate/.test(title)) {
                                title = `{{'${title}' | translate}}`;
                            }

                            innerContent = `<div class="column-header-title" translate="${title}"></div>`;
                        }
                    }

                    let filterable = !!options.model.columns.find(column => column.key == columnKey).dataType;

                    return $compile(`
                                <div class="column-header-content ${filterable ? 'filterable' : ''}"
                                    ng-class="{'filter-visible': columnFilterData.visible && columnFilterData.columnKey == '${columnKey}'}"
                                    ng-click="toggleColumnFilter($event, '${columnKey}')">
                                    ${innerContent}
                                    ${filterable ? `<div class="column-header-filter-icon" ng-include="getHeaderFilterIconUrl('${columnKey}')"></div>` : ''}                                
                                    ${sortable ? `<div ng-click="sortColumn($event, '${columnKey}')" class="column-header-sort-icon" ng-include="getHeaderSortIconUrl('${columnKey}')"></div>` : ''}                                
                                </div>                        
                            `)(scope);
                };

                var onRowsUpdatedFn = options.events.onRowsUpdated;

                options.events.onRowsUpdated = function () {

                    requestAnimationFrame(function () {
                        scope.$digest();
                    });

                    if (onRowsUpdatedFn) onRowsUpdatedFn();
                };

                let onMouseOverRowFn = options.events.onMouseOverRow;

                options.events.onMouseOverRow = rowIndex => {

                    if (options.itemAnchoring) {

                        let item = options.dataSource.items()[rowIndex];

                        if (item) {
                            anchoredItemValue = item[options.itemAnchoring.key];
                            let edgeScrollTop = options.dimensions.rowHeight * rowIndex;
                            let actualScrollTop = element.find('.column-group-body:first').scrollTop();
                            anchoredItemExtraScrollTop = edgeScrollTop - actualScrollTop;
                        }
                    }

                    if (onMouseOverRowFn) onMouseOverRowFn();
                };
                options.events.onDoubleClickRow = (rowIndex, event) => {
                    // scope.toggleMenu(event, rowIndex);
                    // if (scope.itemActionMenu.items[0].enabled === undefined 
                    //     || scope.itemActionMenu.items[0].enabled(rowIndex)) 
                    // {
                    //     scope.itemActionMenu.items[0].callback(rowIndex);
                    // }
                }

                let onMouseOutRowFn = options.events.onMouseOutRow;

                options.events.onMouseOutRow = rowIndex => {

                    if (options.itemAnchoring) {
                        anchoredItemValue = null;
                    }

                    if (onMouseOutRowFn) onMouseOutRowFn();
                };

                if (options.selectOnRowClick) {

                    let rowClickFn = options.rowClick;

                    options.rowClick = (rowIndex, item, event) => {
                        scope.toggleSelect(event, rowIndex);

                        if (rowClickFn) {
                            rowClickFn(rowIndex, item, event);
                        }
                        scope.$digest();
                    }
                }

                options.columnDropTargets = () => {
                    return element.closest('srsng-mega-table').find('.header .group-by');
                };

                options.columnDropped = (column, droppable) => {
                    // Code Added to apply grouping only when the user enables the grouping functionality.
                    if (scope.showGroupBy) {
                        setRowGrouping(column.key);
                        megaTable.updateData();
                    }
                };

                options.rowOverlayContent = rowIndex => {

                    if (!scope.rowGrouping.column) return;

                    let rowGroup = scope.rowGrouping.groups.find(group => rowIndex === group.index);

                    if (!rowGroup) return;

                    return $compile($(`
                        <div class="row-group">
                            <div class="select-button" ng-click="toggleSelect($event, ${rowIndex})">     
                                <ng-include src="getBodyCheckboxUrl(${rowIndex})"></ng-include>
                            </div>
                            <div class="toggle" ng-include="getRowGroupToggleIconUrl(${rowGroup.expanded})"></div>
                            <div class="value">${rowGroup.value}</div>
                        </div>
                    `).on('click', function () { toggleRowGroupExpanded.bind(this)(rowGroup); }))(scope);
                };
            }

            function setRowGrouping(columnKey) {
                /*Added if condition to enable column grouping only if the flag is set*/
                if (columnKey) {
                    if (scope.rowGrouping.column) scope.removeRowGrouping(true);

                    scope.rowGrouping.groups = [];

                    //scope.rowGrouping.columns = options.model.columns.slice();
                    scope.rowGrouping.columnKey = columnKey;
                    scope.rowGrouping.column = options.model.columns.find(c => c.key === columnKey);
                    //options.model.columns = options.model.columns.filter(c => c.key !== columnKey);

                    let sortedColumn = options.model.columns.find(c => c.sortDirection);

                    let sortedItems = options.dataSource.items();

                    if (sortedColumn) {
                        sortedItems = sortService.getSortFn(sortedColumn.dataType)(sortedItems, sortedColumn.key, sortedColumn.sortDirection);
                    }

                    sortedItems = sortService.getSortFn(scope.rowGrouping.column.dataType)(sortedItems, scope.rowGrouping.column.key, SortDirection.ASC);

                    let groupsBefore = 0;

                    sortedItems.forEach((item, index) => {

                        if (!scope.rowGrouping.groups.find(group => group.value === item[scope.rowGrouping.column.key])) {

                            if (groupsBefore > 0) scope.rowGrouping.groups[groupsBefore - 1].itemEndIndex = index - 1 + groupsBefore;

                            groupsBefore++;

                            scope.rowGrouping.groups.push({
                                value: item[scope.rowGrouping.column.key],
                                index: index + groupsBefore - 1,
                                itemStartIndex: index + groupsBefore,
                                itemOffset: groupsBefore
                            });
                        }

                        if (index === sortedItems.length - 1) {
                            scope.rowGrouping.groups[scope.rowGrouping.groups.length - 1].itemEndIndex = index + groupsBefore;
                        }
                    });

                    //megaTable.init(options);
                    options.itemsFiltered(sortedItems);
                }
            }

            function createSelectColumn(options) {
                options.model.columns.forEach(function (column) {
                    if (column.key != MegaTableColumnKey.ROW_OVERLAY) column.columnGroupIndex += 1;
                });

                var hasRowOverlayColumn = options.model.columns.some(function (column) {
                    return column.key == MegaTableColumnKey.ROW_OVERLAY;
                });

                var selectColumnIndex = hasRowOverlayColumn ? 1 : 0;

                options.model.columnGroups.splice(selectColumnIndex, 0, {
                    scrollable: false,
                    locked: true
                });

                options.model.columns.splice(selectColumnIndex, 0, {
                    key: MegaTableColumnKey.SELECT,
                    width: 52,
                    minWidth: 52,
                    maxWidth: 52,
                    columnGroupIndex: selectColumnIndex,
                    dataType: 'boolean'
                });

                scope.allSelected = false;

                let counter = 0;

                scope.getBodyCheckboxUrl = function (rowIndex) {

                    if (!options.dataSource.items()[rowIndex])
                        return '';

                    return `container/ui/assets/img/icons/system-icons-16x16/system-ic-checkbox-${options.dataSource.items()[rowIndex][MegaTableItemProperty.SELECTED] ? 'checked-' : ''}16x16.svg`;
                };

                scope.getHeaderCheckboxUrl = function () {

                    return `container/ui/assets/img/icons/system-icons-16x16/system-ic-checkbox-${scope.allSelected ? 'checked-' : ''}16x16.svg`;
                };
            }

            function createActionColumn(options) {
                var highestIndex = options.model.columns.reduce(function (highestIndex, column) {
                    return column.columnGroupIndex > highestIndex ? column.columnGroupIndex : highestIndex;
                }, 0);

                options.model.columnGroups.push({
                    scrollable: false,
                    locked: true
                });

                var highestColumnIndex = options.model.columns.length;
                options.model.columns.push({
                    key: MegaTableColumnKey.ACTION,
                    width: 56,
                    minWidth: 56,
                    maxWidth: 56,
                    columnGroupIndex: highestIndex + 1,
                    order: highestColumnIndex
                });
            }

            function setRowSelected(rowIndex, selected) {

                let item = options.dataSource.items()[rowIndex];

                if (!!item[MegaTableItemProperty.SELECTED] == !!selected)
                    return;

                //check if selected column is grouping header
                if (selected)
                    item[MegaTableItemProperty.SELECTED] = true;
                else
                    delete item[MegaTableItemProperty.SELECTED];

                if (options.events.onSelectColumnToggled)
                    $timeout(function () {
                        options.events.onSelectColumnToggled(rowIndex, item[MegaTableItemProperty.SELECTED]);
                    });
            }

            function getFilterService(dataType) {
                switch (dataType) {
                    case SortDataType.TEXT: default: return options.paging ? pagingtableColumnTextFilterService : tableColumnTextFilterService;
                    case SortDataType.DATE: return tableColumnDateFilterService;
                    case SortDataType.DURATION: return tableColumnDurationFilterService;
                    case SortDataType.FILE_SIZE: return tableColumnFileSizeFilterService;
                    case SortDataType.IP_ADDRESS: return tableColumnIpAddressFilterService;
                    case SortDataType.NUMBER: return tableColumnNumberFilterService;
                }
            }

            function updateColumnSortState(sortedColumnKey, sortDirection) {
                options.model.columns.forEach(column => {

                    if (column.key == sortedColumnKey)
                        column.sortDirection = sortDirection;
                    else
                        delete column.sortDirection;
                });
            }

            function getColumn(columnKey) {
                return options.model.columns.find(column => column.key == columnKey);
            }
        }
    }
})();
